import { render, staticRenderFns } from "./OvertimeRecord.vue?vue&type=template&id=0b6ac8fc&scoped=true"
import script from "./OvertimeRecord.vue?vue&type=script&lang=js"
export * from "./OvertimeRecord.vue?vue&type=script&lang=js"
import style0 from "./OvertimeRecord.vue?vue&type=style&index=0&id=0b6ac8fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ac8fc",
  null
  
)

export default component.exports